module.exports = __webpack_public_path__ + "static/media/icon_alert_mob.dae2d100.png";